import { history } from '../_helpers/history';

export function handleResponseAsync(response) {
  if (response) {
    const resp = response.data;

    if (resp) {
      const ok = resp.ok;
      if (ok) {
        return resp;
      } else {
        const error = resp.message || resp.statusText;
        throw new Error(error);
      }
    } else {
      const error = resp.statusText;
      throw new Error(error);
    }
  } else {
    history.push('/signin');
  }
}
